// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3CFs6","title":"Header_title__1-vpa","side":"Header_side__34D1X"};